export default [
  { value: "Maintenance", key: -1 },
  { value: "Normal", key: 0 },
  { value: "New", key: 1 },
  { value: "Hot", key: 2 },
];
